import { render, staticRenderFns } from "./PublicationEditPreview.vue?vue&type=template&id=7d514ce6&scoped=true&"
import script from "./PublicationEditPreview.vue?vue&type=script&lang=js&"
export * from "./PublicationEditPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d514ce6",
  null
  
)

export default component.exports